<template>
  <div class="notificacoes">
    <div v-if="show">
      <b-card
        :bg-variant="notificacao.tipo"
        :header="notificacao.titulo"
        text-variant="white"
        class="text-center"
      >
        <b-card-text> {{ notificacao.texto }}</b-card-text>
      </b-card>
    </div>
  </div>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";

export default {
  name: "NotificadorSgcq",

  data() {
    return {
      show: false,
    };
  },

  methods: {},

  watch: {
    notificacao: function () {
      this.show = true;
      setTimeout(() => { this.show = false }, 2500);
    }
  },

  setup() {
    const store = useSgcqStore();
    const { notificacao } = storeToRefs(store);

    return {
      store,
      notificacao,
    };
  },
};
</script>

<style lang="scss" scoped>
.notificacoes {
  position: absolute;
  right: 0;
  width: 300px;
  padding: 8px;
  z-index: 105;
}
</style>
